__turbopack_context__.v({
  "className": "sfprodisplay_b73ba875-module__1jIrva__className",
  "variable": "sfprodisplay_b73ba875-module__1jIrva__variable",
});
